import React, { useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import './DawaAutocomplete.css'; // Import DAWA-specific styles

const DawaAutocomplete = ({ onLocationSelect, value = '', disableField = false }) => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(value);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // Update value from parent
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Dynamically load polyfills and DAWA script
  useEffect(() => {
    const loadScripts = async () => {
      const coreJs = document.createElement('script');
      coreJs.src = 'https://cdnjs.cloudflare.com/ajax/libs/core-js/2.4.1/core.min.js';
      const fetchPolyfill = document.createElement('script');
      fetchPolyfill.src = 'https://cdnjs.cloudflare.com/ajax/libs/fetch/2.0.3/fetch.min.js';
      const dawaScript = document.createElement('script');
      dawaScript.src = 'https://cdn.jsdelivr.net/npm/dawa-autocomplete2@latest/dist/js/dawa-autocomplete2.min.js';
      dawaScript.onload = () => setScriptLoaded(true);

      document.head.appendChild(coreJs);
      document.head.appendChild(fetchPolyfill);
      document.head.appendChild(dawaScript);
    };

    loadScripts();
  }, []);

  useEffect(() => {
    if (scriptLoaded && window.dawaAutocomplete && inputRef.current) {
      const autocomplete = window.dawaAutocomplete.dawaAutocomplete(inputRef.current, {
        select: (selected) => {
          setInputValue(selected.tekst);
          onLocationSelect?.(selected);
        },
      });

      return () => {
        autocomplete.destroy?.(); // If it exists
      };
    }
  }, [scriptLoaded, onLocationSelect]);

  return (
    <div className="autocomplete-container">
      {scriptLoaded ? (
        <TextField
          size="small"
          label="Adresse"
          variant='filled'
          fullWidth
          required
          disabled={disableField}
          value={inputValue}
          error={!inputValue}
          inputRef={inputRef}
          helperText="Skriv adresse"
          onChange={(e) => setInputValue(e.target.value)}
          InputLabelProps={{ shrink: true }}
          InputProps={{ disableUnderline: true }}
          sx={{
            '& .MuiFilledInput-root': {
              borderRadius: 1,
            },
            my: 1,
          }}
        />
      ) : (
        <Skeleton variant="rounded">
          <TextField fullWidth/>
        </Skeleton>
      )}
    </div>
  );
};

export default DawaAutocomplete;